import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab']

  makeActive (event) {
    this.tabTargets.forEach((element) => {
      if (element !== event.target) element.classList.remove('link--active');
    });
    event.target.classList.add('link--active');
  }
}
